import { DanceEventRulesInterface } from '../../..';
import { ParticipantRestrictionDto } from './participant-restriction.dto';

export class DanceEventRulesDto implements DanceEventRulesInterface{
  participationRestriction?: ParticipantRestrictionDto;
}
